<roma-modal-template
  [size]="'sm'"
  [contentMinHeight]="true"
  [headerBottomMargin]="'20px'"
  (cancel)="exit()"
  (success)="submit()"
  class="add-company-modal"
  [textSuccess]="'general.create'"
  [title]="'addAcount.title' | translate"
>
  <div class="client-form">
    <form [formGroup]="form">
      <div class="form-group">
        <label class="form-text" for="name">
          {{ 'addAcount.nameHeader' | translate }}
        </label>
        <input
          type="text"
          class="general-form-control form-control"
          id="name"
          aria-describedby="name"
          formControlName="name"
          (input)="changeName($event)"
          [placeholder]="'addAcount.namePlaceholder' | translate"
          [ngClass]="{
            'is-invalid':
              form.controls.name?.invalid && form.controls.name?.touched
          }"
        />
        <roma-field-error-display
          #fieldName
          fieldName="name"
          [errorMsg]="'general.required'"
          [form]="form"
        >
        </roma-field-error-display>
      </div>
      <div class="form-group">
        <label class="form-text" for="country">
          {{ 'addAcount.country' | translate }}
        </label>

        <rm-select-register
          class="select-payments"
          [items]="countryItems"
          [activeItems]="selectedCountry"
          (changeItems)="onCountryChange($event)"
          [placeholderText]="'addAcount.countryPlaceholder' | translate"
          [isClearable]="true"
          [hasError]="
            form.controls.country?.invalid && form.controls.country?.touched
          "
          [ngClass]="{
            'is-invalid':
              form.controls.country?.invalid && form.controls.country?.touched
          }"
          [isAbsolute]="true"
          [fullWidthList]="true"
          [allOptionsEnabled]="false"
          [listWidth]="'100%'"
          [loadDefaultItem]="false"
          (changeItems)="onCountryChange($event)"
        >
        </rm-select-register>
        <roma-field-error-display
          #fieldName
          fieldName="country"
          [errorMsg]="'general.required'"
          [form]="form"
        >
        </roma-field-error-display>
      </div>
    </form>
  </div>
</roma-modal-template>
